/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('board.dinghy', {
            parent: 'board',
            url: '/board/dinghy',
            views: {
                'content@': {
                    templateUrl: 'app/board/dinghy/dinghyNavbar.html',
                    controller: 'DinghyNavController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
